import api from 'api/axios';

export const login = async (email: string, password: string) => {
  try {
    const response = await api.post('/users/auth/login/', {
      email,
      password,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
